
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var Actions = /*#__PURE__*/function (Actions) {
  Actions["toggleAll"] = "TOGGLE_ALL";
  Actions["toggle"] = "TOGGLE";
  Actions["sortingChanged"] = "SORTING_CHANGED";
  Actions["columnsChanged"] = "COLUMNS_CHANGED";
  Actions["rowsChanged"] = "ROWS_CHANGED";
  Actions["resetSelectedRows"] = "RESET";
  Actions["setDisabled"] = "SET_DISABLED";
  Actions["selectMany"] = "SELECT_MANY";
  return Actions;
}({});

export { Actions };
//# sourceMappingURL=constants.js.map
